export default __webpack_public_path__ + "static/education-primary-circle-2b5c76841587e1482a568009981d2a43.png";